import React from 'react';
import * as Sentry from '@sentry/react';
import { useHistory } from 'react-router-dom';
import { CentsDataGridServer } from 'components/common/dataGrid/dataGridServer';
import TableSearchBar from 'components/common/search/TableSearchBar';
import { usePaginatedTableQuery } from 'hooks/usePaginatedTableQuery';
import { searchUsers } from 'api/admin/users/users';

const COLUMNS = [
  { headerName: 'ID', field: 'id', flex: 0.5 },
  { headerName: 'Name', field: 'name', flex: 1 },
  { headerName: 'Email', field: 'email', flex: 1 },
  { headerName: 'Phone Number', field: 'phone', flex: 1 },
  { headerName: 'Is Verified?', field: 'isVerified', flex: 1 },
  { headerName: 'Created At', field: 'createdAt', flex: 1 },
  { headerName: 'Updated At', field: 'updatedAt', flex: 1 },
  { headerName: 'Roles', field: 'roles', flex: 1 },
  { headerName: 'Business Name', field: 'businessName', flex: 1 },
];

const UsersTable = () => {
  const history = useHistory();
  const {
    data,
    isLoading,
    pageNumber,
    pageSize,
    searchInput,
    handleSearch,
    sortModel,
    handleSortModelChange,
    handlePageChange,
  } = usePaginatedTableQuery({
    queryKey: 'searchUsers',
    queryFn: async ({ searchInput, pageNumber, pageSize, sortBy, sortOrder }) => {
      const { data } = await searchUsers(searchInput, pageNumber, pageSize, sortBy, sortOrder);
      return { users: data.users, total: data.total };
    },
    errorMessage: 'Failed to load users. Showing last loaded results.',
    onQueryError: Sentry.captureException,
  });

  const handleCreateUserClick = () => {
    history.push('/users/new');
  };

  const handleRowClick = ({ id }) => {
    history.push(`/users/${Number(id)}`);
  };

  return (
    <div className="page-container">
      <div className="users-header">
        <h1>Users</h1>
        <button className="create-user-button" onClick={handleCreateUserClick}>
          Create User
        </button>
      </div>
      <div className="users-search-bar">
        <TableSearchBar value={searchInput} placeholder="Find a user" onSearch={handleSearch} />
      </div>
      <CentsDataGridServer
        tableName="USERS"
        data={data?.users ?? []}
        columns={COLUMNS}
        isLoading={isLoading}
        rowCount={data?.total ?? 0}
        pageSize={pageSize}
        page={pageNumber}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        defaultColumnVisibilityModel={{
          updatedAt: false,
        }}
      />
    </div>
  );
};

export default UsersTable;
